// import React, { useState, useEffect, useRef } from "react";
// import api from "../chat/api";
// import { toast } from "react-hot-toast";
// import Tooltip from "../RFP_Manager/Projects/Project Page/Tooltip";
// import { RestoreIcon, PlusIcon, MinusIcon,ActionIcon } from "./ScoringConfigurationSvgs";
// import AddScoringAspectModal from "./AddScoringAspectModal";
// import RemoveAspectModal from "./RemoveAspectModal";
// import ResetToDefaultPopover from "./ResetToDefaultPopover";

// const ScoringConfiguration = () => {
//   const [aspects, setAspects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [restoreLoading, setRestoreLoading] = useState(false);
//   const [selectedPreset, setSelectedPreset] = useState(null);
//   const [source, setSource] = useState(null);
//   const [isAddAspectOpen, setIsAddAspectOpen] = useState(false);
//   const [addAspectInitialTab, setAddAspectInitialTab] = useState("custom"); // ✅ NEW

//   // ── popover state ──
//   const [openPopoverId, setOpenPopoverId] = useState(null);
//   const popoverRef = useRef(null);

//   // ── RESET confirmation popover state ──
//   const [resetPopoverOpen, setResetPopoverOpen] = useState(false);
//   const [resetState, setResetState] = useState("idle"); // "idle" | "loading" | "done"

//   // ── remove confirmation modal state ──
//   const [removeModalOpen, setRemoveModalOpen] = useState(false);
//   const [aspectToRemove, setAspectToRemove] = useState(null);
//   const [removeLoading, setRemoveLoading] = useState(false);
//   const [removeDeleted, setRemoveDeleted] = useState(false); // ── NEW ──
//   // ──────────────────────────────────────────

//   const debounceTimeoutRef = useRef({});

//   const getOrgIdFromUrl = () => {
//     const pathParts = window.location.pathname.split("/");
//     return pathParts[pathParts.length - 1];
//   };

//   const fetchScoringConfig = async () => {
//     try {
//       setLoading(true);
//       const orgId = getOrgIdFromUrl();
//       const response = await api.get(
//         `/api/v1/org/scoring/config/?organization_id=${orgId}`
//       );

//       if (response.data && response.data.aspects) {
//         const mappedAspects = response.data.aspects.map((aspect) => ({
//           id: aspect.id,
//           name: aspect.name,
//           description: aspect.description,
//           weight: aspect.weightage,
//           enabled: aspect.selected,
//           isCustom: aspect.is_custom,
//         }));

//         setAspects(mappedAspects);
//         setSource(response.data.source);
//         setSelectedPreset(response.data.selected_preset);
//       }
//     } catch (error) {
//       console.error("Error fetching scoring configuration:", error);
//       toast.error("Failed to fetch scoring configuration");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchScoringConfig();
//   }, []);

//   // close popover on outside click
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (popoverRef.current && !popoverRef.current.contains(e.target)) {
//         setOpenPopoverId(null);
//       }
//     };
//     if (openPopoverId !== null) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [openPopoverId]);

//   const handleRemoveClick = (aspectId) => {
//     setOpenPopoverId(null);
//     setAspectToRemove(aspectId);
//     setRemoveModalOpen(true);
//   };

//   // ── UPDATED: confirmed delete with Deleting → Deleted → close + refresh ──
//   const handleConfirmRemove = async () => {
//     const orgId = getOrgIdFromUrl();
//     setRemoveLoading(true);
//     try {
//       await api.delete(
//         `/api/v1/org/scoring/aspects/${aspectToRemove}/?organization_id=${orgId}`
//       );
//       setRemoveLoading(false);
//       setRemoveDeleted(true); // show "Deleted"
//       setTimeout(() => {
//         setRemoveModalOpen(false);
//         setAspectToRemove(null);
//         setRemoveDeleted(false);
//         fetchScoringConfig(); // refresh config
//       }, 2000);
//     } catch (error) {
//       console.error("Error deleting aspect:", error);
//       toast.error("Failed to remove aspect");
//       setRemoveLoading(false);
//     }
//   };
//   // ──────────────────────────────────────────────────────────────────────────

//   const handleWeightChange = (id, delta) => {
//     const aspectToUpdate = aspects.find((a) => a.id === id);
//     if (!aspectToUpdate) return;

//     const newWeight = Math.max(1, Math.min(10, aspectToUpdate.weight + delta));

//     setAspects((prev) =>
//       prev.map((aspect) =>
//         aspect.id === id ? { ...aspect, weight: newWeight } : aspect
//       )
//     );

//     if (debounceTimeoutRef.current[id]) {
//       clearTimeout(debounceTimeoutRef.current[id]);
//     }

//     debounceTimeoutRef.current[id] = setTimeout(async () => {
//       const orgId = getOrgIdFromUrl();
//       try {
//         await api.patch(
//           `/api/v1/org/scoring/aspects/${id}/?organization_id=${orgId}`,
//           { weightage: newWeight }
//         );
//       } catch (error) {
//         console.error("Error updating aspect weight:", error);
//         toast.error("Failed to update aspect weight");
//         fetchScoringConfig();
//       }
//     }, 1500);
//   };

//   const toggleAspect = async (id) => {
//     const orgId = getOrgIdFromUrl();

//     setAspects((prev) =>
//       prev.map((aspect) =>
//         aspect.id === id ? { ...aspect, enabled: !aspect.enabled } : aspect
//       )
//     );

//     try {
//       const response = await api.post(
//         `/api/v1/org/scoring/aspects/${id}/toggle-select/?organization_id=${orgId}`
//       );

//       if (response.data) {
//         setAspects((prev) =>
//           prev.map((aspect) =>
//             aspect.id === response.data.id
//               ? { ...aspect, enabled: response.data.selected }
//               : aspect
//           )
//         );
//       }
//     } catch (error) {
//       console.error("Error toggling aspect:", error);
//       toast.error("Failed to toggle aspect selection");

//       setAspects((prev) =>
//         prev.map((aspect) =>
//           aspect.id === id ? { ...aspect, enabled: !aspect.enabled } : aspect
//         )
//       );
//     }
//   };

//   const handleRestore = async () => {
//     const orgId = getOrgIdFromUrl();
//     setRestoreLoading(true);
//     setResetState("loading");

//     try {
//       await api.post(`/api/v1/org/scoring/config/reset/`, {
//         organization_id: parseInt(orgId),
//       });

//       toast.success("Configuration restored to default");

//       setRestoreLoading(false);
//       setResetState("done");

//       setTimeout(() => {
//         setResetPopoverOpen(false);
//         setResetState("idle");
//         fetchScoringConfig(); // refresh config after closing
//       }, 2000);
//     } catch (error) {
//       console.error("Error restoring configuration:", error);
//       toast.error("Failed to restore configuration");
//       setRestoreLoading(false);
//       setResetState("idle");
//     }
//   };

//   const enabledCount = aspects.filter((a) => a.enabled).length;

//   const handleAddAspect = () => {
//     fetchScoringConfig();
//   };

//   return (
//     <div className="flex-1 pr-2 py-2 mt-2 ">
//       <div className="w-full">
//         {/* Header */}
//         <h1 className="text-[18px] font-semibold text-[#09090B] font-outfit">
//           Go/No-Go Scoring Configuration
//         </h1>
//         <p className="text-[14px] text-[#71717A] mb-5 font-outfit border-b pb-2 border-[#CCCCCC]">
//           Configure how bid readiness score will be evaluated for your workspace
//         </p>

//         {/* Evaluation Aspects Section */}
//         <div className="bg-[#FAFAFA] rounded-[12px] border border-[#E4E4E7] px-3 py-2 h-[calc(100vh-150px)] flex flex-col">
//           {/* Section Header - Non-scrollable */}
//           <div className="flex-shrink-0">
//             <div className="flex items-center justify-between mb-2 border-b pb-[8px] border-[#9D9D9D40]">
//               <div>
//                 <h2 className="text-[15px] font-medium text-[#3F3F46] mb-1 font-outfit">
//                   Evaluation Aspects
//                 </h2>
//                 <p className="text-[14px] text-[#52525B] font-outfit">
//                   Assign a weight (1–10) to each criterion. Higher weights =
//                   Greater influence on the final score
//                 </p>
//               </div>

//               <div className="flex gap-3">
//                 {/* Reset button + anchored popover */}
//                 <div className="relative mt-2">
//                   <button
//                     onClick={() => {
//                       setResetPopoverOpen((prev) => !prev);
//                       setResetState("idle");
//                     }}
//                     disabled={
//                       restoreLoading ||
//                       resetState === "loading" ||
//                       resetState === "done"
//                     }
//                     className="disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     <RestoreIcon />
//                   </button>

//                   <ResetToDefaultPopover
//                     open={resetPopoverOpen}
//                     state={resetState}
//                     onClose={() => {
//                       if (resetState === "loading" || resetState === "done")
//                         return;
//                       setResetPopoverOpen(false);
//                       setResetState("idle");
//                     }}
//                     onConfirm={handleRestore}
//                   />
//                 </div>

//                 <button
//                   onClick={() => {
//                     setAddAspectInitialTab("custom"); // ✅ NEW
//                     setIsAddAspectOpen(true);
//                   }}
//                   className="flex items-center gap-2 px-4 py-2 rounded-[8px] bg-[#BB42AE] hover:bg-[#A3398D] transition-colors"
//                 >
//                   <PlusIcon className="w-5 h-5 text-white" />
//                   <span className="text-[14px] font-medium text-white font-outfit">
//                     Add Aspect
//                   </span>
//                 </button>
//               </div>
//             </div>

//             {/* Criteria Status */}
//             <div className="mb-6 flex items-center justify-between">
//               <div className="flex items-center gap-2 text-[14px] font-outfit">
//                 <span className="text-[#00000080] font-medium uppercase border-r pr-[6px] border-[#7D7D7D]">
//                   CRITERIA SET
//                 </span>
//                 <span className="text-[#2DAD4E] font-medium">
//                   {enabledCount} Enabled
//                 </span>
//               </div>

//               {selectedPreset && (
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setAddAspectInitialTab("presets"); // ✅ NEW
//                     setIsAddAspectOpen(true); // ✅ NEW
//                   }}
//                   className="flex items-center gap-1 px-3 py-1 text-[13px] font-medium text-[#BB42AE] border border-[#F0D5EC] rounded-full bg-[#FFF2FE] hover:bg-[#FDF2FA] transition-colors font-outfit"
//                 >
//                   <span className="capitalize">{selectedPreset} Preset</span>
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="12"
//                     height="12"
//                     viewBox="0 0 12 12"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="1.5"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     className="ml-1"
//                   >
//                     <path d="M4.5 9L7.5 6L4.5 3" />
//                   </svg>
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Aspect Cards - Scrollable */}
//           <div className="flex-1 overflow-y-auto custom-scrollbar">
//             {loading ? (
//               <div className="h-full flex items-center justify-center">
//                 <div className="flex flex-col items-center gap-3">
//                   <div className="w-8 h-8 border-4 border-[#E4E4E7] border-t-[#BB42AE] rounded-full animate-spin"></div>
//                   <p className="text-[14px] text-[#71717A] font-outfit">
//                     Fetching...
//                   </p>
//                 </div>
//               </div>
//             ) : (
//               <div className="space-y-4">
//                 {aspects.map((aspect) => (
//                   <div
//                     key={aspect.id}
//                     className="bg-white rounded-[12px] border border-[#E4E4E7] py-2 px-3"
//                   >
//                     <div className="flex items-start justify-between">
//                       {/* Left side - Aspect Info */}
//                       <div className="flex-1 pr-4">
//                         <div className="flex items-center gap-[6px] mb-2">
//                           <div className="w-[2px] h-4 bg-[#BB42AE] rounded-full"></div>
//                           <h3 className="text-[16px] font-semibold text-[#000000B3] font-outfit">
//                             {aspect.name}{" "}
//                             <span
//                               className={`shrink-0 self-start relative top-[-1px] ml-1 text-[11px] font-medium font-outfit px-2 py-0.5 rounded-full border ${
//                                 aspect.isCustom
//                                   ? "text-[#BB42AE] bg-[#BB42AE]/10 border-[#BB42AE]/30"
//                                   : "text-[#52525B] bg-[#F4F4F5] border-[#E4E4E7]"
//                               }`}
//                             >
//                               {aspect.isCustom ? "Custom" : "Default"}
//                             </span>
//                           </h3>

//                           {/* THREE-DOT BUTTON: custom cards only */}
//                           {aspect.isCustom && (
//                             <div
//                               className="relative"
//                               ref={
//                                 openPopoverId === aspect.id ? popoverRef : null
//                               }
//                             >
//                               <button
//                                 onClick={() =>
//                                   setOpenPopoverId(
//                                     openPopoverId === aspect.id
//                                       ? null
//                                       : aspect.id
//                                   )
//                                 }
//                                 className="w-6 h-6 flex items-center mt-[2px] justify-center rounded-md text-[#71717A] hover:bg-[#F4F4F5] transition-colors text-[18px] leading-none"
//                                 title="More options"
//                               >
//                             <ActionIcon />
//                               </button>

//                               {openPopoverId === aspect.id && (
//                                 <div className="absolute left-0 top-8 z-50 bg-white border border-[#E4E4E7] rounded-[8px] shadow-lg py-1 min-w-[160px]">
//                                   <button
//                                     onClick={() => handleRemoveClick(aspect.id)}
//                                     className="flex items-center gap-2 w-full px-3 py-2 text-[14px] text-[#EF4444] hover:bg-[#FEF2F2] transition-colors font-outfit"
//                                   >
//                                     <svg
//                                       xmlns="http://www.w3.org/2000/svg"
//                                       className="w-4 h-4"
//                                       viewBox="0 0 24 24"
//                                       fill="none"
//                                       stroke="currentColor"
//                                       strokeWidth="2"
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                     >
//                                       <polyline points="3 6 5 6 21 6" />
//                                       <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
//                                       <path d="M10 11v6M14 11v6" />
//                                       <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
//                                     </svg>
//                                     Remove Aspect
//                                   </button>
//                                 </div>
//                               )}
//                             </div>
//                           )}
//                         </div>

//                         <p className="text-[14px] text-[#000000B3] font-normal leading-relaxed font-outfit ml-3">
//                           {aspect.description}
//                         </p>
//                       </div>

//                       {/* Right side - Controls */}
//                       <div className="flex items-center gap-4">
//                         {/* Weight Controls */}
//                         <div className="flex items-center gap-3">
//                           <button
//                             onClick={() => handleWeightChange(aspect.id, -1)}
//                             disabled={aspect.weight <= 1}
//                             className="w-6 h-6 flex items-center justify-center rounded-full border border-[#E4E4E7] bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
//                           >
//                             <MinusIcon className="w-4 h-4 text-[#71717A]" />
//                           </button>

//                           <span className="text-[14px] font-medium text-[#000000B3] w-4 text-center font-outfit">
//                             {aspect.weight}
//                           </span>

//                           <button
//                             onClick={() => handleWeightChange(aspect.id, 1)}
//                             disabled={aspect.weight >= 10}
//                             className="w-6 h-6 flex items-center justify-center rounded-full border border-[#E4E4E7] bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
//                           >
//                             <PlusIcon className="w-4 h-4 text-[#71717A]" />
//                           </button>
//                         </div>

//                         {/* Toggle Switch with Tooltip */}
//                         <Tooltip
//                           content="Included in scoring. Impacts final bid readiness score."
//                           placement="left"
//                         >
//                           <button
//                             onClick={() => toggleAspect(aspect.id)}
//                             className={`relative w-12 h-6 rounded-full transition-colors ${
//                               aspect.enabled ? "bg-[#2DAD4E]" : "bg-[#E4E4E7]"
//                             }`}
//                           >
//                             <div
//                               className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform ${
//                                 aspect.enabled
//                                   ? "translate-x-6"
//                                   : "translate-x-0"
//                               }`}
//                             ></div>
//                           </button>
//                         </Tooltip>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <AddScoringAspectModal
//         open={isAddAspectOpen}
//         onClose={() => setIsAddAspectOpen(false)}
//         onAdd={handleAddAspect}
//         orgId={getOrgIdFromUrl()}
//         initialTab={addAspectInitialTab} // ✅ NEW
//       />

//       {/* Remove Aspect Confirmation Modal */}
//       <RemoveAspectModal
//         open={removeModalOpen}
//         onClose={() => {
//           setRemoveModalOpen(false);
//           setAspectToRemove(null);
//           setRemoveDeleted(false);
//         }}
//         onConfirm={handleConfirmRemove}
//         loading={removeLoading}
//         deleted={removeDeleted} // ── NEW ──
//       />
//     </div>
//   );
// };

// export default ScoringConfiguration;
import React, { useState, useEffect, useRef } from "react";
import api from "../chat/api";
import { toast } from "react-hot-toast";
import {
  PiPlus,
  PiArrowCounterClockwise,
  PiMinus,
  PiDotsThree,
  PiScales,
  PiTrash,
} from "react-icons/pi";
import {
  PageHeader,
  PrimaryButton,
  GhostButton,
  Toggle,
  ListCard,
  ListRow,
  StatusPill,
  ViewOnlyBanner,
  useSettings,
} from "./settings/ui";
import AddScoringAspectModal from "./AddScoringAspectModal";
import RemoveAspectModal from "./RemoveAspectModal";
import ResetToDefaultPopover from "./ResetToDefaultPopover";

const ScoringConfiguration = () => {
  // Only owners can mutate this page; everyone else (editor/reviewer/member) gets
  // a read-only view with the action controls hidden. Start hidden until the role
  // resolves (null while loading) so the buttons never flash active on tab switch.
  const { orgRole } = useSettings();
  const canEdit = orgRole === "Owner";

  const [aspects, setAspects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [restoreLoading, setRestoreLoading] = useState(false);
  const [selectedPreset, setSelectedPreset] = useState(null);
  const [source, setSource] = useState(null);
  const [isAddAspectOpen, setIsAddAspectOpen] = useState(false);
  const [addAspectInitialTab, setAddAspectInitialTab] = useState("custom");

  // ── popover state ──
  const [openPopoverId, setOpenPopoverId] = useState(null);
  const popoverRef = useRef(null);

  // ── RESET confirmation popover state ──
  const [resetPopoverOpen, setResetPopoverOpen] = useState(false);
  const [resetState, setResetState] = useState("idle"); // "idle" | "loading" | "done"

  // ── remove confirmation modal state ──
  const [removeModalOpen, setRemoveModalOpen] = useState(false);
  const [aspectToRemove, setAspectToRemove] = useState(null);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [removeDeleted, setRemoveDeleted] = useState(false);

  const debounceTimeoutRef = useRef({});

  const getOrgIdFromUrl = () => {
    const pathParts = window.location.pathname.split("/");
    return pathParts[pathParts.length - 1];
  };

  const fetchScoringConfig = async () => {
    try {
      setLoading(true);
      const orgId = getOrgIdFromUrl();
      const response = await api.get(
        `/api/v1/org/scoring/config/?organization_id=${orgId}`
      );

      if (response.data && response.data.aspects) {
        const mappedAspects = response.data.aspects.map((aspect) => ({
          id: aspect.id,
          name: aspect.name,
          description: aspect.description,
          weight: aspect.weightage,
          enabled: aspect.selected,
          isCustom: aspect.is_custom,
        }));

        setAspects(mappedAspects);
        setSource(response.data.source);
        setSelectedPreset(response.data.selected_preset);
      }
    } catch (error) {
      console.error("Error fetching scoring configuration:", error);
      toast.error("Failed to fetch scoring configuration");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScoringConfig();
  }, []);

  // close popover on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setOpenPopoverId(null);
      }
    };
    if (openPopoverId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openPopoverId]);

  const handleRemoveClick = (aspectId) => {
    if (!canEdit) return;
    setOpenPopoverId(null);
    setAspectToRemove(aspectId);
    setRemoveModalOpen(true);
  };

  const handleConfirmRemove = async () => {
    const orgId = getOrgIdFromUrl();
    setRemoveLoading(true);
    try {
      await api.delete(
        `/api/v1/org/scoring/aspects/${aspectToRemove}/?organization_id=${orgId}`
      );
      setRemoveLoading(false);
      setRemoveDeleted(true);
      setTimeout(() => {
        setRemoveModalOpen(false);
        setAspectToRemove(null);
        setRemoveDeleted(false);
        fetchScoringConfig();
      }, 2000);
    } catch (error) {
      console.error("Error deleting aspect:", error);
      toast.error("Failed to remove aspect");
      setRemoveLoading(false);
    }
  };

  const handleWeightChange = (id, delta) => {
    if (!canEdit) return;
    const aspectToUpdate = aspects.find((a) => a.id === id);
    if (!aspectToUpdate) return;

    const newWeight = Math.max(1, Math.min(10, aspectToUpdate.weight + delta));

    setAspects((prev) =>
      prev.map((aspect) =>
        aspect.id === id ? { ...aspect, weight: newWeight } : aspect
      )
    );

    if (debounceTimeoutRef.current[id]) {
      clearTimeout(debounceTimeoutRef.current[id]);
    }

    debounceTimeoutRef.current[id] = setTimeout(async () => {
      const orgId = getOrgIdFromUrl();
      try {
        await api.patch(
          `/api/v1/org/scoring/aspects/${id}/?organization_id=${orgId}`,
          { weightage: newWeight }
        );
      } catch (error) {
        console.error("Error updating aspect weight:", error);
        toast.error("Failed to update aspect weight");
        fetchScoringConfig();
      }
    }, 1500);
  };

  const toggleAspect = async (id) => {
    if (!canEdit) return;
    const orgId = getOrgIdFromUrl();

    setAspects((prev) =>
      prev.map((aspect) =>
        aspect.id === id ? { ...aspect, enabled: !aspect.enabled } : aspect
      )
    );

    try {
      const response = await api.post(
        `/api/v1/org/scoring/aspects/${id}/toggle-select/?organization_id=${orgId}`
      );

      if (response.data) {
        setAspects((prev) =>
          prev.map((aspect) =>
            aspect.id === response.data.id
              ? { ...aspect, enabled: response.data.selected }
              : aspect
          )
        );
      }
    } catch (error) {
      console.error("Error toggling aspect:", error);
      toast.error("Failed to toggle aspect selection");

      setAspects((prev) =>
        prev.map((aspect) =>
          aspect.id === id ? { ...aspect, enabled: !aspect.enabled } : aspect
        )
      );
    }
  };

  const handleRestore = async () => {
    if (!canEdit) return;
    const orgId = getOrgIdFromUrl();
    setRestoreLoading(true);
    setResetState("loading");

    try {
      await api.post(`/api/v1/org/scoring/config/reset/`, {
        organization_id: parseInt(orgId),
      });

      toast.success("Configuration restored to default");

      setRestoreLoading(false);
      setResetState("done");

      setTimeout(() => {
        setResetPopoverOpen(false);
        setResetState("idle");
        fetchScoringConfig();
      }, 2000);
    } catch (error) {
      console.error("Error restoring configuration:", error);
      toast.error("Failed to restore configuration");
      setRestoreLoading(false);
      setResetState("idle");
    }
  };

  const enabledCount = aspects.filter((a) => a.enabled).length;
  const totalWeight = aspects.reduce(
    (sum, a) => (a.enabled ? sum + a.weight : sum),
    0
  );

  const openAddModal = (tab) => {
    setAddAspectInitialTab(tab);
    setIsAddAspectOpen(true);
  };

  const stepperBtn =
    "w-8 h-8 flex items-center justify-center rounded-[8px] border border-black/15 bg-white text-[#3F3F46] hover:bg-[#F9FAFB] transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white";

  const handleAddAspect = () => {
    fetchScoringConfig();
  };

  return (
    <div className="w-full max-w-[860px] h-full flex flex-col font-outfit">
      <PageHeader
        title="Go/No-Go scoring"
        description="Weight each criterion from 1 to 10. Higher weights count more toward the Go/No-Go score."
        action={
          canEdit && (
            <PrimaryButton icon={PiPlus} onClick={() => openAddModal("custom")}>
              Add criterion
            </PrimaryButton>
          )
        }
      />

      {orgRole && !canEdit && (
        <ViewOnlyBanner icon={PiScales}>
          Scoring is set by admins and applies to every Go/No-Go decision in this workspace.
        </ViewOnlyBanner>
      )}

      {loading ? (
        <p className="py-10 text-center text-[14px] text-[#71717A]">Loading criteria...</p>
      ) : aspects.length === 0 ? (
        <p className="py-10 text-center text-[14px] text-[#71717A]">No criteria yet.</p>
      ) : (
        <>
          <div className="flex items-center justify-between gap-4 mb-3 shrink-0">
            <div className="flex items-center gap-3 min-w-0 flex-wrap">
              <span className="text-[14px] text-[#3F3F46]">
                <b className="font-semibold text-[#18101C]">
                  {enabledCount} of {aspects.length}
                </b>{" "}
                criteria on · total weight {totalWeight}
              </span>
              {selectedPreset && canEdit && (
                <button
                  type="button"
                  onClick={() => openAddModal("presets")}
                  className="rounded-full hover:opacity-80 transition-opacity"
                >
                  <StatusPill tone="neutral" className="capitalize">
                    {selectedPreset} preset
                  </StatusPill>
                </button>
              )}
            </div>

            {canEdit && (
              <div className="relative shrink-0">
                <GhostButton
                  icon={PiArrowCounterClockwise}
                  onClick={() => {
                    setResetPopoverOpen((prev) => !prev);
                    setResetState("idle");
                  }}
                  disabled={
                    restoreLoading ||
                    resetState === "loading" ||
                    resetState === "done"
                  }
                >
                  Reset to default
                </GhostButton>

                <ResetToDefaultPopover
                  open={resetPopoverOpen}
                  state={resetState}
                  onClose={() => {
                    if (resetState === "loading" || resetState === "done")
                      return;
                    setResetPopoverOpen(false);
                    setResetState("idle");
                  }}
                  onConfirm={handleRestore}
                />
              </div>
            )}
          </div>

          <ListCard className="flex-1 min-h-0 overflow-y-auto custom-scrollbar">
            {aspects.map((aspect, index) => {
              const pct =
                aspect.enabled && totalWeight > 0
                  ? Math.round((aspect.weight / totalWeight) * 100)
                  : 0;

              return (
                <ListRow
                  key={aspect.id}
                  off={!aspect.enabled}
                >
                  {canEdit && (
                    <Toggle
                      checked={aspect.enabled}
                      onChange={() => toggleAspect(aspect.id)}
                      title={
                        aspect.enabled
                          ? "Exclude from scoring"
                          : "Include in scoring"
                      }
                    />
                  )}

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-[15px] font-semibold text-[#18101C]">
                        {aspect.name}
                      </span>
                      {aspect.isCustom && <StatusPill tone="purple">Custom</StatusPill>}
                      {!canEdit && !aspect.enabled && (
                        <StatusPill tone="neutral">Not counted</StatusPill>
                      )}
                    </div>
                    {aspect.description && (
                      <p className="mt-0.5 text-[13px] text-[#71717A]">
                        {aspect.description}
                      </p>
                    )}
                  </div>

                  <div className="hidden md:flex flex-col gap-1.5 w-[150px] shrink-0">
                    <div className="h-1.5 rounded-full bg-[#F1EEF3] overflow-hidden">
                      <div
                        className="h-full rounded-full bg-[#A04A97] transition-[width] duration-200"
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                    <span className="text-[12px] text-[#71717A]">
                      {aspect.enabled ? `${pct}% of score` : "Not counted"}
                    </span>
                  </div>

                  {canEdit ? (
                    <div className="flex items-center gap-1.5 shrink-0">
                      <button
                        type="button"
                        aria-label="Decrease weight"
                        onClick={() => handleWeightChange(aspect.id, -1)}
                        disabled={!aspect.enabled || aspect.weight <= 1}
                        className={stepperBtn}
                      >
                        <PiMinus className="text-[14px]" />
                      </button>
                      <span className="w-7 text-center text-[15px] font-semibold text-[#18101C]">
                        {aspect.weight}
                      </span>
                      <button
                        type="button"
                        aria-label="Increase weight"
                        onClick={() => handleWeightChange(aspect.id, 1)}
                        disabled={!aspect.enabled || aspect.weight >= 10}
                        className={stepperBtn}
                      >
                        <PiPlus className="text-[14px]" />
                      </button>
                    </div>
                  ) : (
                    <span className="shrink-0 text-[13px] text-[#71717A] whitespace-nowrap">
                      <b className="text-[15px] font-semibold text-[#18101C]">
                        {aspect.weight}
                      </b>{" "}
                      / 10
                    </span>
                  )}

                  {canEdit &&
                    (aspect.isCustom ? (
                      <div
                        className="relative shrink-0"
                        ref={openPopoverId === aspect.id ? popoverRef : null}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setOpenPopoverId(
                              openPopoverId === aspect.id ? null : aspect.id
                            )
                          }
                          className="w-8 h-8 flex items-center justify-center rounded-[8px] text-[#71717A] hover:bg-black/[0.04] transition-colors"
                          title="More options"
                        >
                          <PiDotsThree className="text-[20px]" />
                        </button>

                        {openPopoverId === aspect.id && (
                          <div className={`absolute right-0 ${index >= aspects.length - 2 && aspects.length > 3 ? "bottom-9" : "top-9"} z-50 min-w-[160px] py-1 bg-white border border-black/10 rounded-[8px] shadow-[0_8px_24px_rgba(0,0,0,0.08)]`}>
                            <button
                              type="button"
                              onClick={() => handleRemoveClick(aspect.id)}
                              className="flex items-center gap-2 w-full px-3 py-2 text-[14px] text-[#E21919] hover:bg-[rgba(226,25,25,0.06)] transition-colors"
                            >
                              <PiTrash className="text-[16px]" />
                              Remove Aspect
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      <span className="w-8 shrink-0" aria-hidden="true" />
                    ))}
                </ListRow>
              );
            })}
          </ListCard>
        </>
      )}

      <AddScoringAspectModal
        open={isAddAspectOpen}
        onClose={() => setIsAddAspectOpen(false)}
        onAdd={handleAddAspect}
        orgId={getOrgIdFromUrl()}
        initialTab={addAspectInitialTab}
      />

      <RemoveAspectModal
        open={removeModalOpen}
        onClose={() => {
          setRemoveModalOpen(false);
          setAspectToRemove(null);
          setRemoveDeleted(false);
        }}
        onConfirm={handleConfirmRemove}
        loading={removeLoading}
        deleted={removeDeleted}
      />
    </div>
  );
};

export default ScoringConfiguration;
